/**
 * Fixed Deposit Service
 * Migrated from 3in1cms legacy/fdApi.ts
 */

import { request } from "../core/request";
import { API_RESPONSE_CODES, OPERATION_IDS } from "./constants";
import type { IBrokerResponse, IFdDetailsResponse, IFdRetrieveResponse } from "../types/fdTypes";

/**
 * Fetch broker ID for customer
 * @param data - Customer ID
 * @returns Broker response with broker ID and name
 */
export const fetchBrokerID = async (data: { customerId: string }): Promise<IBrokerResponse> => {
  try {
    const response = (await request<IBrokerResponse, { customerId: string }>({
      operationId: OPERATION_IDS.fdFetchBrokerId,
      requestData: data,
    })) as IBrokerResponse;

    const { statusCode } = response;

    if (statusCode === API_RESPONSE_CODES.STATUS_CODE_7001) {
      return response;
    }

    return { statusCode };
  } catch (error) {
    console.error("Error in fetchBrokerID", error);
    return { statusCode: API_RESPONSE_CODES.STATUS_CODE_7002 };
  }
};

/**
 * Get Fixed Deposit SDP details
 * @param data - Customer ID and deposit ID
 * @returns FD details response
 */
export const getFDSDPDetails = async (data: {
  customerId: string;
  depositId: string;
}): Promise<IFdDetailsResponse | undefined> => {
  try {
    const response = (await request<IFdDetailsResponse, { customerId: string; depositId: string }>({
      operationId: OPERATION_IDS.fdDetails,
      requestData: data,
    })) as IFdDetailsResponse;
    return response;
  } catch (err) {
    console.error("Error in getFDSDPDetails", err);
    return undefined;
  }
};

/**
 * Retrieve FD details
 * @param data - ID and mobile number
 * @returns FD retrieve response
 */
export const callFdRetrieve = async (data: {
  id: string;
  mobileNo: string;
}): Promise<IFdRetrieveResponse | undefined> => {
  try {
    const response = (await request<IFdRetrieveResponse, { id: string; mobileNo: string }>({
      operationId: OPERATION_IDS.fdretrieve,
      requestData: data,
    })) as IFdRetrieveResponse;
    return response;
  } catch (err) {
    console.error("Error in call Fd Retrieve", err);
    return undefined;
  }
};
